// whole thing probably needs a bit of a tidy up

const quantityAdjustersInit = () => {

  const inRange = (x, range) => {
    const max = Math.max(...range);
    const min = Math.min(...range);
    return x >= min && x <= max;
  }

  const getAmount = (adjuster, input) => {
    let step = 1;
    const inputAdjusterAmount = adjuster.dataset.inputAdjusterAmount;
    if (!inputAdjusterAmount && input && input.getAttribute('step')) {
      step = parseFloat(input.getAttribute('step'));
    } else if (inputAdjusterAmount) {
      step = parseFloat(inputAdjusterAmount);
    }
    return step;
  }
    
  const disableButtons = (buttons, current, range) => {
    buttons.forEach(button => {
      const amount = getAmount(button);
      if(!inRange(current + amount, range)) {
        button.setAttribute('disabled', true)
      } else {
        button.removeAttribute('disabled')
      }
    })
  }

  const quantityAdjusters = document.querySelectorAll('[data-input-adjuster-selector]');

  quantityAdjusters.forEach(adjuster => {
    const selector = adjuster.dataset.inputAdjusterSelector;
    if (!selector) {
      return false;
    }
    const input = document.querySelector(selector);
    if (!input) {
      return false;
    }
    const amount = getAmount(adjuster, input);
    if (!amount) {
      return false;
    }  

    //default to zero
    const min = input.getAttribute('min') ? parseFloat(input.getAttribute('min')) : 0;

    //default to 999
    const max = input.getAttribute('max') ? parseFloat(input.getAttribute('max')) : 999;

    adjuster.addEventListener('click', e => {
     
      e.preventDefault();
      const currentVal = input.value ? parseFloat(input.value) : 0;
      const newValue = Math.min(Math.max(min, currentVal + amount), max);
      input.value = newValue;
      disableButtons(quantityAdjusters, newValue, [min, max])
    }, false);

    const currentVal = input.value ? parseFloat(input.value) : 0;
    disableButtons(quantityAdjusters, currentVal, [min, max])
  })
}

export default quantityAdjustersInit;